export default function Logo() {
  return (
    <img
      className="h-7 w-auto shrink-0"
      loading="lazy"
      alt="Ergeon"
      src="/logo26@2x.png"
    />
  );
}
